import { Card, Grid, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import useStyles from '../indexcss';
import ChatTicket from './ChatTicket';

const TicketPreview = () => {
  const classes = useStyles();
  const location = useLocation();
  const ticketData = location.state && location.state.ticketData;

  const handleCancelRequest = () => {
    console.log('Cancel Request clicked');
  };

  return (
    <Card className={classes.TicketCard}>
      {ticketData && (
        <>
          <Grid container spacing={6} alignItems="center">
            <Grid item xs={12} md={8}>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} md={5}>
                  <Typography className={classes.ticketHeaderPreview}>{ticketData.header}</Typography>
                </Grid>
                <Grid item xs={12} md={7}>
                  <Typography className={ticketData.status === 'Closed' ? classes.greenStatus : classes.PendingStatus}>{ticketData.status}</Typography>{' '}
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} md={4}>
              <div onClick={handleCancelRequest} className={classes.resolvedStatus}>
                Cancel Request
              </div>
            </Grid>
          </Grid>
          <Grid container spacing={2} className={classes.GridAlignBorder}>
            <Grid item xs={12} md={1} style={{ paddingLeft: '0px' }}>
              <Typography className={classes.headerCardinfo}>Request ID</Typography>
              <Typography className={classes.subTypoCardinfo}>{ticketData.ticketNumber}</Typography>
            </Grid>
            <Grid item xs={12} md={1} style={{ paddingLeft: '0px' }}>
              <Typography className={classes.headerCardinfo}>Date & Time</Typography>
              <Typography className={classes.subTypoCardinfo}>{ticketData.ticketDate}</Typography>
            </Grid>
            <Grid item xs={12} md={2} style={{ paddingLeft: '0px' }}>
              <Typography className={classes.headerCardinfo}>Request Type</Typography>
              <Typography className={classes.subTypoCardinfo}>Technical</Typography>
            </Grid>
          </Grid>
          <ChatTicket ticketData={ticketData} />
        </>
      )}
    </Card>
  );
};

export default TicketPreview;
